// import { BiPlus } from 'react-icons/bi';
import React, { useEffect, useState } from 'react';
import DatePicker from '../../../../components/FormElement/DatePicker';
import { FiTrash2 } from 'react-icons/fi';
import Input from '../../../../components/FormElement/Search';
import TextArea from '../../../../components/FormElement/TextArea';
import { useFormik } from 'formik';
import service from '../../../../services/vacancy';
import { FormWrapper } from '../style';
import Button from '../../../../components/FormElement/Button';
import LangTab from '../../../../components/FormElement/LangTab';
import { useHideModal } from '../../../../hooks';
import * as Yup from 'yup';
import { useShowAlert } from '../../../../hooks/useAlerts';
import Spinner from '../../../../components/Spinner';
import { Col, Row } from 'antd';

function Form({ edit, fetch }) {
  const [language, setLanguage] = useState('UZL');
  const { error } = useShowAlert();
  const [loading, setLoading] = useState(false);
  const { hideModal } = useHideModal();

  const validationSchema = Yup.object({
    title: Yup.object().shape({
      UZK: Yup.string().required('Kiritish shart!'),
      UZL: Yup.string().required('Kiritish shart!'),
      RUS: Yup.string().required('Kiritish shart!'),
      ENG: Yup.string().required('Kiritish shart!'),
    }),
    date: Yup.string().required('Kiritish shart'),
    count: Yup.number().required('Kiritish shart'),
    conditions: Yup.array()
      .of(
        Yup.object().shape({
          UZK: Yup.string().required('Kiritish shart!'),
          UZL: Yup.string().required('Kiritish shart!'),
          RUS: Yup.string().required('Kiritish shart!'),
          ENG: Yup.string().required('Kiritish shart!'),
        }),
      )
      .required('Must have items'),
    requirements: Yup.array()
      .of(
        Yup.object().shape({
          UZK: Yup.string().required('Kiritish shart!'),
          UZL: Yup.string().required('Kiritish shart!'),
          RUS: Yup.string().required('Kiritish shart!'),
          ENG: Yup.string().required('Kiritish shart!'),
        }),
      )
      .required('Must have items'),
    tasks: Yup.array()
      .of(
        Yup.object().shape({
          UZK: Yup.string().required('Kiritish shart!'),
          UZL: Yup.string().required('Kiritish shart!'),
          RUS: Yup.string().required('Kiritish shart!'),
          ENG: Yup.string().required('Kiritish shart!'),
        }),
      )
      .required('Must have items'),
  });
  const formik = useFormik({
    initialValues: {
      title: {
        UZL: '',
        UZK: '',
        RUS: '',
        ENG: '',
      },
      count: '',
      date: '',
      conditions: [
        {
          UZL: '',
          UZK: '',
          RUS: '',
          ENG: '',
        },
      ],
      requirements: [
        {
          UZL: '',
          UZK: '',
          RUS: '',
          ENG: '',
        },
      ],
      tasks: [
        {
          UZL: '',
          UZK: '',
          RUS: '',
          ENG: '',
        },
      ],
    },
    validationSchema,
    onSubmit: (values) => {
      const payload = {
        ...values,
      };
      setLoading(true);
      if (edit) {
        service
          .update(edit, payload)
          .then(() => {
            hideModal();
            fetch();
            formik.resetForm();
          })
          .catch((err) => {
            console.log(err);
            error(
              "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring",
            );
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        service
          .create(payload)
          .then(() => {
            hideModal();
            fetch();
            formik.resetForm();
          })
          .catch((err) => {
            console.log(err);
            error(
              "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring",
            );
          })
          .finally(() => {
            setLoading(false);
          });
      }
    },
  });

  useEffect(() => {
    if (edit) {
      setLoading(true);
      service
        .getOne(edit)
        .then((resp) => {
          formik.setValues({
            title: {
              UZL: resp?.title?.UZL,
              UZK: resp?.title?.UZK,
              RUS: resp?.title?.RUS,
              ENG: resp?.title?.ENG,
            },
            count: resp?.count,
            date: resp?.date,
            conditions: resp?.conditions
              ? resp?.conditions
              : [
                  {
                    UZL: '',
                    UZK: '',
                    RUS: '',
                    ENG: '',
                  },
                ],
            requirements: resp?.requirements
              ? resp?.requirements
              : [
                  {
                    UZL: '',
                    UZK: '',
                    RUS: '',
                    ENG: '',
                  },
                ],
            tasks: resp?.tasks
              ? resp?.tasks
              : [
                  {
                    UZL: '',
                    UZK: '',
                    RUS: '',
                    ENG: '',
                  },
                ],
          });
        })
        .catch((err) => {
          console.log(err);
          error(
            "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring",
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, []);
  const onLangChange = (key) => {
    setLanguage(key);
  };

  if (loading) return <Spinner />;
  return (
    <FormWrapper>
      <form onSubmit={formik.handleSubmit}>
        <LangTab
          defaultActiveKey='1'
          onChange={onLangChange}
        />
        <Input
          id='title'
          name='title'
          label='Lavozimi'
          width={100}
          placeholder='Lavozimi'
          onChange={(e) => {
            formik.setFieldValue(`title.${language}`, e.target.value);
          }}
          value={formik.values?.title[language]}
          status={formik?.errors?.title && formik.touched.title ? 'error' : ''}
        />
        <div className='date'>
          <Input
            id='count'
            name='count'
            placeholder={'Soni'}
            label={'Soni'}
            type='number'
            width={100}
            onChange={formik.handleChange}
            value={formik.values.count}
            status={
              formik?.errors?.count && formik.touched.count ? 'error' : ''
            }
          />
          <div className='mtop'>
            <DatePicker
              onChange={(date) => formik.setFieldValue('date', date)}
              value={formik.values.date}
              label={'Sana'}
              width={'100%'}
              status={
                formik?.errors?.date && formik.touched.date ? 'error' : ''
              }
            />
          </div>
        </div>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            {formik.values?.conditions?.map((item, i) => (
              <div
                key={i}
                className={formik.values.conditions.length > 1 ? 'area' : ''}
              >
                <div className='textArea'>
                  <TextArea
                    labelTitle={'Shartlar'}
                    id={`conditions[${i}]`}
                    name={`conditions[${i}]`}
                    onChange={(e) => {
                      formik.setFieldValue(
                        `conditions[${i}].${language}`,
                        e.target.value,
                      );
                    }}
                    value={item?.[language]}
                    label={'Shartlar'}
                    placeholder='Shart'
                    status={
                      formik?.errors?.conditions && formik.touched.conditions
                        ? 'error'
                        : ''
                    }
                    height={'auto'}
                    autoSize={{ minRows: 2, maxRows: 5 }}
                    // height={item.length <= 100 ? "50px" : "120px"}
                  />
                </div>
                {formik.values.conditions.length > 1 && (
                  <button
                    className='del'
                    type='button'
                    onClick={() => {
                      const deleteVal = [...formik.values.conditions];
                      deleteVal.splice(i, 1);
                      formik.setFieldValue('conditions', deleteVal);
                    }}
                  >
                    <FiTrash2 />
                  </button>
                )}
              </div>
            ))}
            {/* <AddButton>
              <div className='border'></div>
              <button
                className='add'
                type='button'
                onClick={() => {
                  formik.setFieldValue('conditions', [
                    ...formik.values.conditions,
                    {
                      UZL: '',
                      UZK: '',
                      RUS: '',
                      ENG: '',
                    },
                  ]);
                }}
              >
                <BiPlus size={16} />
              </button>
              <div className='border'></div>
            </AddButton> */}
          </Col>
          <Col span={24}>
            {formik.values?.requirements?.map((item, i) => (
              <div
                key={i}
                className={formik.values.requirements.length > 1 ? 'area' : ''}
              >
                <div className='textArea'>
                  <TextArea
                    labelTitle={'Talablar'}
                    id={`requirements[${i}]`}
                    name={`requirements[${i}]`}
                    onChange={(e) => {
                      formik.setFieldValue(
                        `requirements[${i}].${language}`,
                        e.target.value,
                      );
                    }}
                    value={item?.[language]}
                    label={'Talablar'}
                    placeholder='Talablar'
                    status={
                      formik?.errors?.requirements &&
                      formik.touched.requirements
                        ? 'error'
                        : ''
                    }
                    height={'auto'}
                    autoSize={{ minRows: 2, maxRows: 5 }}
                    // height={item.length <= 100 ? "50px" : "120px"}
                  />
                </div>
                {formik.values.requirements.length > 1 && (
                  <button
                    className='del'
                    type='button'
                    onClick={() => {
                      const deleteVal = [...formik.values.requirements];
                      deleteVal.splice(i, 1);
                      formik.setFieldValue('requirements', deleteVal);
                    }}
                  >
                    <FiTrash2 />
                  </button>
                )}
              </div>
            ))}
            {/* <AddButton>
              <div className='border'></div>
              <button
                className='add'
                type='button'
                onClick={() => {
                  formik.setFieldValue('requirements', [
                    ...formik.values.requirements,
                    {
                      UZL: '',
                      UZK: '',
                      RUS: '',
                      ENG: '',
                    },
                  ]);
                }}
              >
                <BiPlus size={16} />
              </button>
              <div className='border'></div>
            </AddButton> */}
          </Col>
          <Col span={24}>
            {formik.values?.tasks?.map((item, i) => (
              <div
                key={i}
                className={formik.values.tasks.length > 1 ? 'area' : ''}
              >
                <div className='textArea'>
                  <TextArea
                    labelTitle={'Vazifalar'}
                    id={`tasks[${i}]`}
                    name={`tasks[${i}]`}
                    onChange={(e) => {
                      formik.setFieldValue(
                        `tasks[${i}].${language}`,
                        e.target.value,
                      );
                    }}
                    value={item?.[language]}
                    label={'Vazifalar'}
                    placeholder='Vazifalar'
                    status={
                      formik?.errors?.tasks && formik.touched.tasks
                        ? 'error'
                        : ''
                    }
                    height={'auto'}
                    autoSize={{ minRows: 2, maxRows: 5 }}
                    // height={item.length <= 100 ? "50px" : "120px"}
                  />
                </div>
                {formik.values.tasks.length > 1 && (
                  <button
                    className='del'
                    type='button'
                    onClick={() => {
                      const deleteVal = [...formik.values.tasks];
                      deleteVal.splice(i, 1);
                      formik.setFieldValue('tasks', deleteVal);
                    }}
                  >
                    <FiTrash2 />
                  </button>
                )}
              </div>
            ))}
            {/* <AddButton>
              <div className='border'></div>
              <button
                className='add'
                type='button'
                onClick={() => {
                  formik.setFieldValue('tasks', [
                    ...formik.values.tasks,
                    {
                      UZL: '',
                      UZK: '',
                      RUS: '',
                      ENG: '',
                    },
                  ]);
                }}
              >
                <BiPlus size={16} />
              </button>
              <div className='border'></div>
            </AddButton> */}
          </Col>
        </Row>

        <Button
          className='send'
          htmlType='submit'
          text={edit ? 'Yangilash' : "Qo'shish"}
          width='100%'
        />
      </form>
    </FormWrapper>
  );
}

export default Form;
